const { getAxiosInstance } = require('../connection');

module.exports = {
    fetchFormMetadata: function (formId) {
        return getAxiosInstance({
            method: 'GET',
            url:  '/form/' + encodeURIComponent(formId),
            json: true,
        }).then((response) => response.data);
    },
    sendAnswer: function (formId, data) {
        return getAxiosInstance({
            method: 'POST',
            url:  '/form/' + encodeURIComponent(formId),
            json: true,
            data,
        }).then((response) => response.data);
    },
    fetchConditionalOptions: function (questionId, data) {
        return getAxiosInstance({
            method: 'POST',
            url:  '/formoptions/' + encodeURIComponent(questionId),
            json: true,
            data,
        }).then((response) => response.data);
    },
};
